import { useQuery } from '@tanstack/react-query'
import { liveCheckinMonthsLevelsRewardsService } from '../../services/lives-checkins-months-levels-rewards'

export const MONTH_REWARDS_KEY = 'getLiveCheckinsMonthsLevelsRewards'

export function useGetMonthRewards(liveCheckinMonthId: number | null | undefined) {
  const enabled = !!liveCheckinMonthId
  const { data, isLoading, refetch } = useQuery({
    queryKey: [MONTH_REWARDS_KEY, liveCheckinMonthId],
    enabled,
    queryFn: () =>
      liveCheckinMonthsLevelsRewardsService.getList({
        take: 200,
        liveCheckinMonthId: liveCheckinMonthId!,
      }),
  })

  return {
    monthRewards: data?.data ?? [],
    isLoading,
    refetch,
  }
}
